import { Button, Col, Row, Space, Typography } from "antd";
import React, { useState } from "react";
import DetailItem from "../../../components/DetailItem";
import MemberTransferHistory from "./MemberTransferHistory";
import AddMember from "../../group/CreateComponents/AddMember";
import { EditOutlined } from "@ant-design/icons";
import { ListItem } from "../../group/CreateComponents/GroupInformation";

interface Props {
	member?: ListItem | undefined;
	isSmall?: boolean;
	setSelectedMember: React.Dispatch<ListItem | undefined>;
}
const { Text } = Typography;
const MemberInformation: React.FC<Props> = ({ member, isSmall, setSelectedMember }) => {
	const [showTransferHistory, setShowTransferHistory] = useState<boolean>(false);
	const [showAdd, setShowAdd] = useState(false);
	const [showDetail, setShowDetail] = useState(false);

	return member !== undefined ? (
		<div
			className="grey-card transfer-user-card"
			style={{ marginTop: 20, minHeight: "initial" }}
		>
			<Row gutter={[24, 0]}>
				<Col
					span={12}
					md={6}
				>
					<img
						className="card-user-photo"
						alt={member?.user?.nickName}
						src={member?.user?.profilePic ?? "/images/no-preview.jpg"}
						style={{
							width: 130,
						}}
					/>
				</Col>
				<Col
					span={12}
					md={6}
				>
					<DetailItem
						label="Full Name"
						value={member?.user?.nickName?.toUpperCase()}
					/>
					<DetailItem
						label="Total Listing"
						value={member?.user?.listingCount}
					/>
				</Col>
				<Col
					span={24}
					md={12}
				>
					<DetailItem label="Fee">
						<Space>
							<Button
								block
								type="primary"
								onClick={() => setShowDetail(true)}
								style={{
									width: "max-content",
								}}
							>
								See Detail Fees
							</Button>
							<Button
								type="primary"
								onClick={() => setShowAdd(true)}
								icon={<EditOutlined />}
							></Button>
						</Space>
					</DetailItem>

					{!isSmall && (
						<Space>
							<Button
								block
								type="primary"
								onClick={() => setShowTransferHistory(true)}
							>
								See History
							</Button>
						</Space>
					)}
				</Col>

				<AddMember
					open={showAdd}
					onClose={() => {
						setShowAdd(false);
					}}
					onSelect={(user) => {
						setSelectedMember({
							groupMemberId: member.groupMemberId,
							user,
						});
					}}
					selectedMember={member}
					resetListFee={false}
				/>

				<AddMember
					open={showDetail}
					onClose={() => {
						setShowDetail(false);
					}}
					selectedMember={member}
					isDetail
				/>
			</Row>
			<MemberTransferHistory
				open={showTransferHistory}
				userId={member?.user?.userId}
				onClose={() => setShowTransferHistory(false)}
				type="modal"
			/>
		</div>
	) : (
		<div
			className="grey-card transfer-user-card flex-justify"
			style={{ marginTop: 20 }}
		>
			<Space
				direction="vertical"
				className="center"
			>
				<Text>Detail Member Empty</Text>
				<Text type="secondary">Select member first in order to display information</Text>
			</Space>
		</div>
	);
};
export default MemberInformation;
